
import { defineComponent, ref, onBeforeMount } from "vue";
import { ApiBase } from "@/core/api";
import { useI18n } from "vue-i18n";
import _ from "lodash";

interface Filter {
  name: string;
  type: string;
  merchant: string;
  taggings: Array<string>;
}

export default defineComponent({
  name: "filter-warehouses-dropdown",
  components: {},
  emits: ["submit-filter", "reset-filter"],
  setup(props, { emit }) {
    const { t } = useI18n();

    const formRef = ref<null | HTMLFormElement>(null);
    const formData = ref<Filter>({
      name: "",
      type: "",
      merchant: "",
      taggings: [],
    });

    const options = ref({
      type: [],
      merchant: [],
      taggings: [],
    });

    const submit = () => {
      emit("submit-filter", formData.value);
    };

    const handleReset = () => {
      formRef.value?.resetFields();
      emit("reset-filter");
    };

    const getMerchantSourceData = async (value, id?) => {
      let params = id
        ? {
            id: id,
          }
        : {
            search_value: value,
          };
      const { data } = await ApiBase.getMerchantSourceData({
        ...params,
        options: { include_fields: ["name", "country_iso_2", "address"] },
      });
      if (data.code == 0) {
        options.value.merchant = data.data;
      }
    };

    const debounceMerchantSourceSearch = _.debounce(
      getMerchantSourceData,
      1000
    );

    const searchMerchantSourceItems = (query: string) => {
      debounceMerchantSourceSearch(query);
    };

    const getTaggingData = async () => {
      const { data } = await ApiBase.getTaggingData({
        short_key: ["warehouse_type", "warehouse_taggings"],
      });
      if (data.code == 0) {
        options.value.type = data.data.warehouse_type.items;
        options.value.taggings = data.data.warehouse_taggings.items;
      }
    };

    const getFromInfo = async () => {
      Promise.all([getTaggingData(), getMerchantSourceData("")])
        .then(() => {
          // console.log(result);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    onBeforeMount(() => {
      getFromInfo();
    });

    return {
      t,
      formData,
      formRef,
      options,
      submit,
      handleReset,
      searchMerchantSourceItems,
    };
  },
});
